onmount = require("onmount");

$(document).on("turbolinks:load", function () {

  $('body').on('change', 'select.js-field-type-select', function(){
    filterDataTypeSelect($(this).closest('.js-custom-data-field-row'));
  });

  $('body').on('change', 'select.js-data-type-select', function(){
    displayOptions($(this).closest('.js-custom-data-field-row'));
  });

  $('body').on('click', '.js-remove-attribute', function(){
    setTimeout(toggleRemoveAttributeLinks, 400);
  });

  $('.js-custom-data-field-row').each(function () {
    prefillRow($(this));
  });

  toggleRemoveAttributeLinks();

});

onmount('.js-custom-data-field-row', function () {
  prefillRow($(this));
  toggleRemoveAttributeLinks();
});

function toggleRemoveAttributeLinks() {
  var rows = $('.js-custom-data-field-row:visible');

  rows.find('.js-remove-attribute').toggle(rows.length > 1);
}

function prefillRow(row) {
  var fieldTypeSelect = row.find('select.js-field-type-select');

  if(fieldTypeSelect.prop('disabled')) {
    return;
  }

  if(!fieldTypeSelect.val()) {
    var previousValue = row.prevAll('.js-custom-data-field-row').first().find('select.js-field-type-select').val();

    if(previousValue) {
      fieldTypeSelect.val(previousValue);
      fieldTypeSelect.selectpicker("refresh");
    }
  }

  if(fieldTypeSelect.val()) {
    filterDataTypeSelect(row);
  }
}

function filterDataTypeSelect(row) {
  var value = row.find('select.js-field-type-select').val();
  var dataTypeSelect = row.find('select.js-data-type-select');

  dataTypeSelect.val('');

  if(value) {
    dataTypeSelect.prop('disabled', false);
    dataTypeSelect.find('option').prop('disabled', false);

    if(value == 'client') {
      dataTypeSelect.find('option[value="vaccine"]').prop('disabled', true);
    } else if(value == 'pet') {
      dataTypeSelect.find('option[value="address"]').prop('disabled', true);

    }

  } else {
    dataTypeSelect.prop('disabled', true);
  }

  dataTypeSelect.selectpicker("refresh");
  displayOptions(row);
}

function displayOptions(row) {
  if (
    row.find('select.js-data-type-select option:selected').val() == "multiple_option" ||
    row.find('select.js-data-type-select option:selected').val() == "single_option"
  ) {
    row.find('.js-field-options').slideDown("fast");
  } else {
    row.find('.js-field-options').slideUp("fast");
  }
}
